export default "__VITE_ASSET__B9JVWDwM__"